import React from "react";
import { Card } from "@jsq/ds/core";
import VerifyTwoFAContainer, {
  type VerifyTwoFAContainerProps,
} from "apps/portal/Portal/common/VerifyTwoFAContainer";
import classNames from "classnames";
import styles from "./styles.scss";

export type VerifyTwoFACardProps = VerifyTwoFAContainerProps & {
  twoFaSmsLastFourDigits?: string;
  splitScreen?: boolean;
};

/**
 * TODO: https://junipersquare.atlassian.net/browse/ENG-17608 - refactor into LoginCard
 * A generic UI component representing the VerifyTwoFA card that is re-used by login & update 2FA workflows.
 * Props include everything provided to VerifyTwoFAContainer plus additional arena info to render the
 * logo and footer.
 * Note that showPoweredBy is only included as part of the card for P2.0 workflows.
 */
export const VerifyTwoFACard = (props: VerifyTwoFACardProps) => {
  const {
    twoFAInputErrorMessage,
    shouldClearTwoFAInput,
    showCheckbox,
    showGoBackButton = false,
    isComponentLoading,
    isButtonLoading = false,
    handleSubmit,
    handleInputChange,
    sendCode,
    twoFaType,
    onBackButtonClick,
    showPoweredBy,
    twoFaSmsLastFourDigits = "",
    arena,
    splitScreen,
    showAuthCodeTooltip = false,
  } = props;

  return (
    <Card
      className={classNames(
        styles.VerifyTwoFA__Card,
        splitScreen && styles.VerifyTwoFA__Card__split,
      )}
    >
      <VerifyTwoFAContainer
        twoFAInputErrorMessage={twoFAInputErrorMessage}
        shouldClearTwoFAInput={shouldClearTwoFAInput}
        showCheckbox={showCheckbox}
        showGoBackButton={showGoBackButton}
        isComponentLoading={isComponentLoading}
        isButtonLoading={isButtonLoading}
        handleSubmit={handleSubmit}
        handleInputChange={handleInputChange}
        sendCode={sendCode}
        twoFaSmsLastFourDigits={twoFaSmsLastFourDigits}
        twoFaType={twoFaType}
        onBackButtonClick={onBackButtonClick}
        showPoweredBy={showPoweredBy}
        arena={arena}
        showAuthCodeTooltip={showAuthCodeTooltip}
      />
    </Card>
  );
};

export default VerifyTwoFACard;
